import { StateToken } from '@ngxs/store';

export enum PaymentMethodType {
  Card = 'CARD',
  SEPA = 'SEPA',
  Alipay = 'ALIPAY',
}

export interface PaymentMethodSetup {
  types: PaymentMethodType[];
  setupSecret: string;
}

export interface PaymentMethod {
  paymentMethodId: string;
  type: PaymentMethodType;
  name: string;
  default: boolean;
  detailsCard?: CreditCardPaymentMethod;
  detailsSepa?: SepaPaymentMethod;
  detailsAlipay?: AlipayPaymentMethod;
}

export interface PaymentMethodInstance {
  last4: string;
  country: string;
}

export interface CreditCardPaymentMethod extends PaymentMethodInstance {
  brand: string;
  expYear: number;
  expMonth: number;
}

export interface SepaPaymentMethod extends PaymentMethodInstance {}

export interface AlipayPaymentMethod extends PaymentMethodInstance {}

export interface CustomerPaymentMethodsStateModel {
  setup?: PaymentMethodSetup;
  methods: PaymentMethod[];
}

export const CUSTOMER_PAYMENT_METHODS_STATE_TOKEN = new StateToken<CustomerPaymentMethodsStateModel>(
  'customerPaymentMethods',
);
